import 'focus-visible';
import Drupal from './core/Drupal';
import DDTemplates from './core/DDTemplates';
import FixNavigation from './core/FixNavigation';
import TermNavigation from './core/TermNavigation';
import FetchSourceImages from './core/FetchSourceImages';
import Breakpoints from './components/Breakpoints';
import Headroom from './components/Headroom';
import Toolbar from './header/Toolbar';
import Shift from './utils/Shift';
import Sticky from './utils/Sticky';
import Navigation from './components/Navigation';
import Placeholder from './utils/Placeholder';
import PanelGroup from './components/PanelGroup';
import Hero from './home/Hero';
import News from './home/News';
import Stats from './home/Stats';
import FixTranslate from './core/FixTranslate';
import CalendarFeed from './core/CalendarFeed';
import CalendarGridFilters from './core/CalendarGridFilters';

// ----------------------------------------------------------------------------
// Homepage Specific Behaviors.
// ----------------------------------------------------------------------------

const homeBehaviors = () => {
  const $modal = document.querySelectorAll('#custom-modal-overlay')[0];
  const $storiesButton = document.querySelectorAll('#stories-video');
  const video = document.querySelector('#video');
  // Hero Block
  document.querySelectorAll('.home-hero.block').forEach((element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // News Block
  document.querySelectorAll('.home-news.block').forEach((element) => {
    if (!element.News) {
      element.News = new News(element);
    }
  });

  // Stats Block
  document.querySelectorAll('.home-stats.block').forEach((element) => {
    if (!element.Stats) {
      element.Stats = new Stats(element);
    }
  });

  function hideModal() {
    document.querySelectorAll('body')[0].classList.remove('no-scroll');
    $modal.style.display = 'none';
    video.pause();
    video.currentTime = 0;
  }

  document.querySelectorAll('.close-modal-button').forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      hideModal();
    });
  });

  document.querySelectorAll('#custom-modal-overlay').forEach((element) => {
    document.querySelectorAll('.page')[0].insertBefore(element, null);
  });

  // Hide modal if modal is open and escape key is pressed.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && $modal.style.display === 'block') {
      hideModal();
    }
  });

  // Hide modal if the target of the click isn't the modal.
  document.addEventListener('click', (e) => {
    if ((e.target !== $modal.firstElementChild
      && e.target !== $modal.firstElementChild.firstElementChild
      && e.target !== $storiesButton[0])
      && $modal.style.display === 'block') {
      hideModal();
    }
  });

  $storiesButton.forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('body')[0].classList.add('no-scroll');
      $modal.style.display = 'block';
    });
  });
};

// ----------------------------------------------------------------------------
// Core Theme Behaviors.
// ----------------------------------------------------------------------------

const coreBehaviors = () => {
  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  document.querySelectorAll('#nice-menu-3').forEach((element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element, {
        expandActiveMenus: true,
        closeUnnestedMenus: false,
        focusout: false,
        hover: false,
      });

      // Expands all root terms on all desktop breakpoints.
      Breakpoints.on('desktop desktop_xl', 'enter', () => {
        element.querySelectorAll('a.depth-1 + .navigation__toggle').forEach((toggle) => {
          if (toggle.getAttribute('aria-expanded') === 'false') {
            toggle.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
          }
        });
      });
    }
  });

  document.querySelectorAll('.page-header').forEach((element) => {
    // Controls the states of the menu and search states
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
    // Controls the states of the menu and search states
    if (!element.Shift) {
      element.Shift = new Shift(element);
    }
  });

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Headroom) {
      element.Headroom = new Headroom(element);
    }
  });

  // Term Navigation
  document.querySelectorAll('.term-navigation').forEach((element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Calendar of Events View
  // document.querySelectorAll('.calendar-feed').forEach((element) => {
  //   if (!element.CalendarFeed) {
  //     element.CalendarFeed = new CalendarFeed(element);
  //   }
  // });
  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element, {
        useFilters: true,
        filters: {
          All: 2,
          'Alta Sponsored Event': 555,
          'Board Meeting': 316,
          'Community Event': 554,
          'Cultural Diversity': 634,
          'Deaf+': 638,
          'Public Meetings': 637,
          Trainings: 635,
          'Vendor Events': 636,
        },
      });
    }
  });

  document.querySelectorAll('.view-grid-calendar').forEach((element) => {
    if (!element.calendarGridFilters) {
      element.calendarGridFilters = new CalendarGridFilters(element, {
        filters: {
          All: 2,
          'Alta Sponsored Event': 555,
          'Board Meeting': 316,
          'Community Event': 554,
          'Cultural Diversity': 634,
          'Deaf+': 638,
          'Public Meetings': 637,
          Trainings: 635,
          'Vendor Events': 636,
        },
      });
    }
  });

  // Footerlink accordions
  document.querySelectorAll('.node-accordion').forEach((element) => {
    if (!element.PanelGroup) {
      element.PanelGroup = new PanelGroup(element);
    }
  });

  // Placeholder text
  document.querySelectorAll('.node-webform input').forEach((element) => {
    if (!element.Placeholder) {
      element.Placeholder = new Placeholder(element);
    }
  });

  // Fix Translate dropdown
  document.querySelectorAll('.goog-te-menu-frame').forEach((element) => {
    if (!element.FixTranslate) {
      element.FixTranslate = new FixTranslate(element);
    }
  });
};

// ----------------------------------------------------------------------------
// Load homepage behaviors if we're on the frontpage.
// ----------------------------------------------------------------------------

if (document.body.classList.contains('front')) {
  Drupal.behavior(homeBehaviors);
}

// ----------------------------------------------------------------------------
// Load core behaviors.
// ----------------------------------------------------------------------------

Drupal.behavior(coreBehaviors);

// ----------------------------------------------------------------------------
// If we're in development mode...
// Open up all missing images within a new tab/window.
// ----------------------------------------------------------------------------

if (process.env.NODE_ENV === 'development') {
  document.body.FetchSourceImages = new FetchSourceImages();
}
